import { render, staticRenderFns } from "./transaction-nav.vue?vue&type=template&id=008c11ce&"
import script from "./transaction-nav.vue?vue&type=script&lang=js&"
export * from "./transaction-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports